import React from "react";
import {  HashRouter } from "react-router-dom";
import Loading from "../common/pages/Loading/Loading";
import { useAuth } from "../contexts/auth";
import AppRoutes from "./app.routes";
import AuthRoutes from "./auth.routes";


const Routes: React.FC = () => {
    const { signed, loading } = useAuth();

    if (loading) return <Loading />;
    
    return (
        <HashRouter>
            {signed
                ? <AppRoutes />
                : <AuthRoutes />
            }
        </HashRouter>
    )
}


export default Routes;